export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نجاح"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
}